import { text } from "@hubble/tokens/web";
import type { BaseTextProps } from "@hubble/web/dist/esm/components/Text";

export type TextComponentBaseSize = "sm" | "md" | "lg";
export type TextComponentDisplaySize = TextComponentBaseSize | "xl" | "xxl";
export interface TextComponentProps<T = TextComponentBaseSize>
  extends BaseTextProps {
  size?: T;
  semiBold?: boolean;
  reflectableContent?: string;
}

type OverridingStyles = Pick<TextComponentProps, "fontSize" | "lineHeight">;
type Device = "mobile" | "desktop";
export const displayProps: Record<
  Device,
  Record<TextComponentDisplaySize, OverridingStyles>
> = {
  desktop: {
    sm: {
      fontSize: text.base.scale[40].fontSize,
      lineHeight: text.base.scale[36].lineHeight
    },
    md: {
      fontSize: text.base.scale[48].fontSize,
      lineHeight: text.base.scale[40].lineHeight
    },
    lg: {
      fontSize: "60px",
      lineHeight: "60px"
    },
    xl: {
      fontSize: "80px",
      lineHeight: "80px"
    },
    xxl: {
      fontSize: text.base.scale[96].fontSize,
      lineHeight: "92px"
    }
  },
  mobile: {
    sm: {
      fontSize: text.base.scale[40].fontSize,
      lineHeight: "44px"
    },
    md: {
      fontSize: "44px",
      lineHeight: "44px"
    },
    lg: {
      fontSize: text.base.scale[48].fontSize,
      lineHeight: text.base.scale[48].fontSize
    },
    xl: {
      fontSize: text.base.scale[56].fontSize,
      lineHeight: text.base.scale[56].fontSize
    },
    xxl: {
      fontSize: "64px",
      lineHeight: "64px"
    }
  }
};

export const headingProps: Record<
  Device,
  Record<TextComponentBaseSize, OverridingStyles>
> = {
  desktop: {
    sm: {
      fontSize: text.base.scale[24].fontSize,
      lineHeight: text.base.scale[20].lineHeight
    },
    md: {
      fontSize: text.base.scale[32].fontSize,
      lineHeight: text.base.scale[28].lineHeight
    },
    lg: {
      fontSize: text.base.scale[36].fontSize,
      lineHeight: text.base.scale[32].lineHeight
    }
  },
  mobile: {
    sm: {
      fontSize: text.base.scale[20].fontSize,
      lineHeight: text.base.scale[16].lineHeight
    },
    md: {
      fontSize: text.base.scale[24].fontSize,
      lineHeight: text.base.scale[18].lineHeight
    },
    lg: {
      fontSize: text.base.scale[28].fontSize,
      lineHeight: text.base.scale[24].lineHeight
    }
  }
};

export const bodyProps: Record<TextComponentBaseSize, OverridingStyles> = {
  sm: text.base.scale[14],
  md: {
    fontSize: text.base.scale[16].fontSize,
    lineHeight: text.base.scale[14].lineHeight
  },
  lg: {
    fontSize: text.base.scale[18].fontSize,
    lineHeight: text.base.scale[16].lineHeight
  }
};
